import { Launch as LaunchIcon } from '@mui/icons-material'
import { Box, Button } from '@mui/material'

const KonfirSignInButton = () => {
  return (
    <Box sx={{ alignSelf: 'flex-start' }}>
      <Button
        href="https://app.konfir.com/sign-in"
        target="_blank"
        rel="noopener noreferrer"
        variant="text"
        sx={{
          color: 'primary.main',
          fontSize: '12px',
          fontWeight: 400,
          textTransform: 'none',
          padding: 0,
          minWidth: 'auto',
          gap: 1,
          justifyContent: 'flex-start',
          '&:hover': {
            backgroundColor: 'transparent',
            textDecoration: 'underline',
          },
        }}
      >
        Open in Konfir
        <LaunchIcon sx={{ fontSize: '16px' }} />
      </Button>
    </Box>
  )
}

export default KonfirSignInButton
